//Third-party packages
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

//Custom imports
import { uiManageModalNotification } from '../../redux/actions/ui';
import { startDelete } from '../../redux/actions/users';
import { Content } from './Content';

/**
 * 
    Author: QBK
    Date: 29-09-2021
 */
export const ConfirmDelete = () => {
  const dispatch = useDispatch(); //react-redux hook to be able to dispatch the actions
  const { active } = useSelector(state => state.user); //we get the users from the state

  const handleSuccess = () => {
    dispatch(uiManageModalNotification()); //we close the confirmation modal
    dispatch(startDelete(active.PkUsuarios)); //We dispatch the action passing as a parameter the user id
  };

  //The HTML is being rendered
  return (
    <Content
      title={'¿Quieres borrar el usuario?'}
      text={'El usuario quedará eliminado definitivamente del sistema'}
      action={handleSuccess}
    />
  );
};
